import { AccessAccountsStatusDto, AccessAccountStatus } from 'common/enums/enums';

export const accessAccountsStatusDtoToTableStatus: Record<AccessAccountsStatusDto, AccessAccountStatus> = {
  [AccessAccountsStatusDto.Pending]: AccessAccountStatus.Pending,
  [AccessAccountsStatusDto.Finished]: AccessAccountStatus.Finished,
};
